import { useState, useEffect } from "react";
import { Link } from "react-router-dom";

export default function EditAccount() {
  const [email, setEmail] = useState("");
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate fetching email
    setTimeout(() => {
      setEmail("demo@example.com");
      setLoading(false);
    }, 800); // Fake delay
  }, []);

  const handleUpdate = (e) => {
    e.preventDefault();

    if (newPassword !== confirmPassword) {
      alert("New passwords do not match!");
      return;
    }

    alert("Password updated (simulated demo only)");
    setCurrentPassword("");
    setNewPassword("");
    setConfirmPassword("");
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <p className="text-gray-600 text-lg">Loading...</p>
      </div>
    );
  }

  return (
    <div className="flex min-h-screen bg-white">
      <div className="w-1/4 border-r px-6 py-8">
        <div className="flex flex-col space-y-4 font-medium text-black">
          <Link to="/edit-profile" className="hover:text-purple-700 hover:pl-2 transition-all">
            Edit Profile
          </Link>
          <Link
            to="/edit-account"
            className="text-purple-700 border-l-4 border-purple-700 pl-2"
          >
            Edit Account
          </Link>
          <button
            onClick={() => {
              alert("Simulated logout (no token used)");
            }}
            className="text-left text-black hover:text-purple-700 hover:pl-2 transition-all"
          >
            Log out
          </button>
        </div>
      </div>

      <div className="flex-1 px-10 py-8">
        <h1 className="text-3xl font-semibold mb-6">Edit Account</h1>

        <form onSubmit={handleUpdate} className="space-y-6 max-w-lg">
          <div>
            <label className="block font-medium mb-1">Email</label>
            <input
              type="text"
              value={email}
              disabled
              className="w-full border rounded px-4 py-2 bg-gray-100 text-gray-600"
            />
          </div>

          <div>
            <label className="block font-medium mb-1">Current password</label>
            <input
              type="password"
              value={currentPassword}
              onChange={(e) => setCurrentPassword(e.target.value)}
              className="w-full border rounded px-4 py-2"
              placeholder="Enter your current password"
              required
            />
          </div>

          <div>
            <label className="block font-medium mb-1">New password</label>
            <input
              type="password"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              className="w-full border rounded px-4 py-2"
              placeholder="Enter new password"
              required
            />
          </div>

          <div>
            <label className="block font-medium mb-1">Confirm password</label>
            <input
              type="password"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              className="w-full border rounded px-4 py-2"
              placeholder="Confirm your new password"
              required
            />
          </div>

          <button
            type="submit"
            disabled={
              loading ||
              !currentPassword ||
              !newPassword ||
              !confirmPassword ||
              newPassword !== confirmPassword
            }
            className="w-full bg-indigo-600 hover:bg-indigo-700 text-white py-3 rounded font-semibold disabled:opacity-50"
          >
            {loading ? "Updating..." : "Save Changes"}
          </button>
        </form>
      </div>
    </div>
  );
}